import { render, staticRenderFns } from "./newactivity.vue?vue&type=template&id=44149d73&"
import script from "./newactivity.vue?vue&type=script&lang=js&"
export * from "./newactivity.vue?vue&type=script&lang=js&"
import style0 from "./newactivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports